import { ChangeEvent, FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { TYPE_FILES_ALLOWED } from 'constants/defaultConstants';
import { allowedFileDocument } from 'utils/allowedFileDocument';
import errorSwal from 'utils/errorSwal';
import IconTooltip from '../../Icon/IconTooltip';

type AddCouncilBodyProps = {
  onChangeFiles: (files: File[]) => void; // eslint-disable-line
};

const AddBoardsDocumentSectionHeader: FC<AddCouncilBodyProps> = ({
  onChangeFiles,
}) => {
  const { t } = useTranslate();

  const handleChangeFiles = async (event: ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    const newFiles = fileList ? [...fileList] : [];

    if (newFiles.length === 0) return;

    const validationResults = await Promise.all(
      newFiles.map(async (file) => allowedFileDocument(file))
    );

    if (validationResults.some((isValid) => !isValid)) {
      errorSwal(t('InvalidFile'));
      return;
    }

    onChangeFiles(newFiles);
  };

  return (
    <div className="nk-block-head-content col-12">
      <div className="row">
        <div className="col-md-6 d-flex align-items-center">
          <h5 className="nk-block-title mb-0 mb-0">{t('Documentation')}</h5>
          <IconTooltip
            id="documentation-info"
            tooltip={t('TheseDocumentsBeAvailablePartners')}
          />
        </div>
        <div className="col-md-6 text-right">
          <div className="form-group">
            <label
              htmlFor="custom-file"
              className="btn btn-sm btn-dim btn-primary mb-0"
            >
              <em className="icon ni ni-plus" />
              <span>{t('AddDocumentation')}</span>
            </label>

            <input
              type="file"
              id="custom-file"
              name="custom-file"
              style={{ display: 'none' }}
              accept={TYPE_FILES_ALLOWED}
              onChange={handleChangeFiles}
              multiple
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBoardsDocumentSectionHeader;
